import { render, staticRenderFns } from "./Hunters.vue?vue&type=template&id=4e2a6b3c&scoped=true&"
import script from "./Hunters.vue?vue&type=script&lang=js&"
export * from "./Hunters.vue?vue&type=script&lang=js&"
import style0 from "./Hunters.vue?vue&type=style&index=0&id=4e2a6b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a6b3c",
  null
  
)

export default component.exports